import { Component, OnInit } from '@angular/core';
import { IdSesionService } from './providers/id-sesion.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Buses Pullman Tur';
  
  constructor(
    public idSesionService: IdSesionService,
  ) { }

  ngOnInit() {
    this.idSesionService.verificarSesionID();
  }
}
